export const queryKeys = {
  projects: {
    all: () => ["projects"] as const,
    lists: () => [...queryKeys.projects.all(), "list"] as const,
    list: (params: { page: number; limit: number; search?: string }) =>
      [
        ...queryKeys.projects.lists(),
        {
          page: params.page,
          limit: params.limit,
          search: (params.search ?? "").trim().substring(0, 256),
        },
      ] as const,
    details: () => [...queryKeys.projects.all(), "detail"] as const,
    detail: (projectId: string) =>
      [...queryKeys.projects.details(), projectId] as const,
    dashboard: (params: { page: number; limit: number; search?: string }) =>
      [
        ...queryKeys.projects.all(),
        "dashboard",
        {
          page: params.page,
          limit: params.limit,
          search: (params.search ?? "").trim().substring(0, 256),
        },
      ] as const,
    helpSelect: () => [...queryKeys.projects.all(), "help-select"] as const,
    trackAudits: (params: { page: number; limit: number; search?: string }) =>
      [
        ...queryKeys.projects.all(),
        "track-audits",
        {
          page: params.page,
          limit: params.limit,
          search: (params.search ?? "").trim().substring(0, 256),
        },
      ] as const,
  },
  users: {
    all: () => ["users"] as const,
    lists: () => [...queryKeys.users.all(), "list"] as const,
    list: (params: { page: number; limit: number; search?: string }) =>
      [
        ...queryKeys.users.lists(),
        {
          page: params.page,
          limit: params.limit,
          search: (params.search ?? "").trim().substring(0, 256),
        },
      ] as const,
    details: () => [...queryKeys.users.all(), "detail"] as const,
    detail: (userId: string) => [...queryKeys.users.details(), userId] as const,
    dropdown: (params: { search?: string }) =>
      [
        ...queryKeys.users.all(),
        "dropdown",
        { search: (params.search ?? "").trim().substring(0, 256) },
      ] as const,
  },
  reports: {
    all: () => ["reports"] as const,
    projects: () => [...queryKeys.reports.all(), "projects"] as const,
    project: (projectId: string) =>
      [...queryKeys.reports.projects(), projectId] as const,
  },
  auth: {
    me: () => ["auth", "me"] as const,
  },
} as const;

